import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { AG_GRID_LOCALE_FR } from '@ag-grid-community/locale';
import { AgGridReact } from "ag-grid-react";
import { getPublicLeadColumnDefinition } from "shared/topchef.grid"

import { Lead, PublicLead } from "shared/topchef.types"

ModuleRegistry.registerModules([AllCommunityModule]);

export interface BriefsListProps {
    leads: Lead[] | PublicLead[],
    detailsRenderer: any,
    height: string,
    paginateResults: boolean
}

const BriefsList = (props: BriefsListProps) => {

  const columnsDefinition = getPublicLeadColumnDefinition({detailsRenderer: props.detailsRenderer});

  return (
    <div className="ag-theme-alpine" id="all_briefs" style={{ width: '100%', height: props.height }}>
        <AgGridReact
          rowData={props.leads}
          columnDefs={columnsDefinition}
          overlayNoRowsTemplate={"Il n'y a aucun brief..."}
          pagination={props.paginateResults}
          paginationPageSize={20}
          defaultColDef={{
            flex: 1,
            resizable: true,
            autoHeight: true,
          }}
          localeText={AG_GRID_LOCALE_FR}
        />
    </div>
  );

  };

  export default BriefsList;
